const TIMETAB_TIME_ZONE = "Europe/Zurich";
const LOCAL_TIMESTAMP_PATTERN = /^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})/;
const EXPLICIT_TIMEZONE_PATTERN = /(Z|[+-]\d{2}:?\d{2}|GMT|UTC)$/i;

const DATE_TIME_FORMATTER = new Intl.DateTimeFormat("de-CH", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
  timeZone: TIMETAB_TIME_ZONE,
});

function formatFormatterParts(date) {
  const parts = DATE_TIME_FORMATTER.formatToParts(date).reduce((accumulator, part) => {
    if (part.type !== "literal") accumulator[part.type] = part.value;
    return accumulator;
  }, {});

  if (!parts.day || !parts.month || !parts.year || !parts.hour || !parts.minute) {
    return "";
  }

  return `${parts.day}.${parts.month}.${parts.year}, ${parts.hour}:${parts.minute}`;
}

function formatLocalTimestamp(rawValue) {
  const raw = String(rawValue || "").trim();
  if (!raw || EXPLICIT_TIMEZONE_PATTERN.test(raw)) return "";

  const match = raw.match(LOCAL_TIMESTAMP_PATTERN);
  if (!match) return "";

  const [, year, month, day, hour, minute] = match;
  return `${day}.${month}.${year}, ${hour}:${minute}`;
}

export function formatTimestampLabel(value) {
  if (!value) return "";

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? "" : formatFormatterParts(value);
  }

  const raw = String(value).trim();
  if (!raw) return "";

  const localTimestamp = formatLocalTimestamp(raw);
  if (localTimestamp) return localTimestamp;

  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return "";

  return formatFormatterParts(parsed);
}
